import {Component, EventEmitter, Input, Output} from '@angular/core';
import {League, LeagueStatus, Lookups} from "@model";
import {AbstractComponent} from "../abstract.component";

@Component({
  selector: 'app-league-grid-list',
  templateUrl: './league-grid-list.component.html',
  styleUrl: './league-grid-list.component.scss',
  standalone: false
})
export class LeagueGridListComponent extends AbstractComponent{
  @Input() leagues: League[] = [];
  @Input({required: true}) languages: Lookups[] = [];
  @Output() scrolled: EventEmitter<void> = new EventEmitter<void>();
  @Output() onRightButtonClickCallback: EventEmitter<League> = new EventEmitter<League>();


  constructor() {
    super();
  }

  ngOnInit(): void {
  }


  protected readonly LeagueStatus = LeagueStatus;
}
